export enum TaskPriority {
  none,
  urgent,
  high,
  normal,
  low,
}
